import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { Button, FullBox, Typography } from 'seagull';
import ExternalLinkButton from '~/components/ExternalLinkButton';
import { useLocaleKeys } from '~/i18n';
import styles from './APIKeysEmptyState.module.scss';
export const APIKeysEmptyState = (param)=>{
    let { generateKey } = param;
    const { t: texts } = useLocaleKeys('pages.apiKeysPage');
    return /*#__PURE__*/ _jsxs(FullBox, {
        className: styles.emptyState,
        testId: "api-keys-empty-state",
        children: [
            /*#__PURE__*/ _jsx(Typography, {
                variant: "h6",
                weight: "normal",
                testId: "api-keys-empty-state-title",
                children: texts.emptyTitle()
            }),
            /*#__PURE__*/ _jsxs(Typography, {
                variant: "paragraph1",
                skin: "secondary",
                testId: "api-keys-empty-state-description",
                align: "center",
                style: {
                    width: 800
                },
                children: [
                    texts.emptyDescription(),
                    /*#__PURE__*/ _jsx(ExternalLinkButton, {
                        href: "https://docs.sayanchor.com",
                        underline: "none",
                        openInNewTab: true,
                        testId: "api-keys-empty-state-api-docs-link",
                        bi: {
                            name: 'api_keys_empty_state_api_docs_link'
                        },
                        children: texts.apiDocumentation()
                    }),
                    texts.emptyDescriptionMiddle(),
                    /*#__PURE__*/ _jsx(ExternalLinkButton, {
                        href: "https://intercom.help/anchor-billing/en/articles/12293577-anchor-api-webhooks",
                        underline: "none",
                        openInNewTab: true,
                        testId: "api-keys-empty-state-knowledge-base-link",
                        bi: {
                            name: 'api_keys_empty_state_knowledge_base_link'
                        },
                        children: texts.knowledgeBase()
                    }),
                    texts.emptyDescriptionEnd()
                ]
            }),
            /*#__PURE__*/ _jsx(Button, {
                bi: {
                    name: 'generate_first_api_key'
                },
                onClick: generateKey,
                testId: "api-keys-empty-state-generate-key-button",
                children: texts.generateApiKey()
            })
        ]
    });
};
